import { render, staticRenderFns } from "./VCRadar2023JP.vue?vue&type=template&id=09d5fd91"
import script from "./VCRadar2023JP.vue?vue&type=script&lang=js"
export * from "./VCRadar2023JP.vue?vue&type=script&lang=js"
import style0 from "./VCRadar2023JP.vue?vue&type=style&index=0&id=09d5fd91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports